module.exports = __webpack_public_path__ + "img/dda9464.png";